import {request, setAuthInHeader, removeAuthInHeader} from "@/api/request";
import { get } from "lodash";

let $api = {
    $auth: {
        login(params) {
            // 로그인 전에 기존 토큰 제거
            removeAuthInHeader();
            return request.newPost('api/admin/login', params).then(({data}) => data);
        },
        changePass(params) {
            return request.newPut('normal/api/account', params).then(({data}) => data);
        },
        checkPass(params) {
            return request.newPost('normal/api/account/password', params).then(({data}) => data);
        },
        refreshToken(params) {
            return request.newPost('api/admin/reissue', params).then(({data}) => data);
        }
    },
    $admin:{
        getAdmin(params) {
            return request.newGet("super/api/admin", params).then(({data}) => data);
        },
        getClientAdmin(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/manage-info/admin/${key}`, params).then(({data}) => data);
        },
        getAdminDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/admin/${key}`, params).then(({data}) => data);
        },
        createAdmin(params) {
            return request.newPost("super/api/admin", params).then(({data}) => data);
        },
        updateAdmin(params) {
            let key = params.adIdx
            delete params.adIdx
            return request.newPut(`super/api/admin/${key}`, params).then(({data}) => data);
        },
        deleteAdmin(params) {
            let key = params.adIdx
            delete params.adIdx
            return request.newDelete(`super/api/admin/${key}`, params).then(({data}) => data);
        },
        getDashBoard(params){
            return request.newGet(`normal/api/dashboard`, params).then(({data}) => data);
        },
        pauseAdmin(params) {
            let adIdx = params.adIdx
            delete params.adIdx
            return request.newPatch(`super/api/admin/${adIdx}/pause`, params).then(({data}) => data);
        },
        setClientAdmin(params) {
            let key = params.key
            delete params.key
            return request.newPost(`super/api/customer/${key}/manager`, params).then(({data}) => data);
        },
        finishClientAdmin(params) {
            return request.newDelete("super/api/customer/manager", params).then(({data}) => data);
        },
        updateAdminSelf(params) {
            return request.newPut('normal/api/account', params).then(({data}) => data);
        },
        changeAdminPassword(params) {
            let key = params.key
            delete params.key
            return request.newPost(`super/api/admin/${key}/reset-password`, params).then(({data}) => data);
        }
    },
    $parser : {
        getCrawlingScript(params) {
            return request.newGet("super/api/crawling-script", params).then(({data}) => data);
        },
        getParserDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/crawling-script/${key}`, params).then(({data}) => data);
        },
        createParser(params) {
            return request.newPost("super/api/crawling-script", params).then(({data}) => data);
        },
        updateParser(params) {
            let key = params.key
            delete params.key
            return request.newPut(`super/api/crawling-script/${key}`, params).then(({data}) => data);
        },
        deleteParser(params){
            let key = params.key
            delete params.key
            return request.newDelete(`super/api/crawling-script/${key}`, params).then(({data}) => data);
        }
    },
    $client:{
        getClient(params) {
            return request.newGet("normal/api/customer", params).then(({data}) => data);
        },
        getClientSuper(params) {
            return request.newGet("super/api/customer", params).then(({data}) => data);
        },
        createClient(params) {
            return request.newPost("super/api/customer", params).then(({data}) => data);
        },
        getClientSuperDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/customer/${key}`, params).then(({data}) => data);
        },
        getCrawlingHistory(params) {
            return request.newGet(`normal/api/crawling`, params).then(({data}) => data);
        },
        getClientKeyword(key,params) {
            return request.newGet(`normal/api/customer/${key}/keyword`, params).then(({data}) => data);
        },
        updateClientKeyword(key,params) {
            return request.newPut(`normal/api/customer/${key}/keyword`, params).then(({data}) => data);
        },
        getClientStopword(key,params) {
            return request.newGet(`normal/api/customer/${key}/stopword`, params).then(({data}) => data);
        },
        getClientKeyWordCloud(key,params) {
            return request.newGet(`normal/api/wordcloud-setting/customer/${key}`, params).then(({data}) => data);
        },
        updateClientWordCloud(key,params) {
            return request.newPut(`normal/api/wordcloud-setting/customer/${key}`, params).then(({data}) => data);
        },
        getClientStopWordCloud(params) {
            return request.newGet(`super/api/wordcloud-global-setting`, params).then(({data}) => data);
        },
        updateClientStopWordCloud(params) {
            return request.newPut(`super/api/wordcloud-global-setting`, params).then(({data}) => data);
        },
        updateClientStopword(key,params) {
            return request.newPut(`normal/api/customer/${key}/stopword`, params).then(({data}) => data);
        },
        getClientDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/customer/info/${key}`, params).then(({data}) => data);
        },
        getClientDetailSuper(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/customer/${key}`, params).then(({data}) => data);
        },
        disposeClient(params) {
            return request.newDelete("super/api/customer/manager", params).then(({data}) => data);
        },
        updateClient(params) {
            let key = params.cuIdx
            delete params.cuIdx
            return request.newPut(`super/api/customer/${key}`, params).then(({data}) => data);
        },
        deleteClient(params) {
            return request.newDelete("super/api/customer", params).then(({data}) => data);
        },
        getClientAutoMail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/customer/info/${key}`, params).then(({data}) => data);
        },
        updateClientAutoMail(params) {
            let cuIdx = params.cuIdx
            delete params.cuIdx
            return request.newPut(`normal/api/customer/${cuIdx}/info/v3`, params).then(({data}) => data);
        },
        getClientManager(params) {
            let key = params.key
            delete params.key
            return request.newGet(`super/api/customer/${key}/manager`, params).then(({data}) => data);
        },
        getClientAdmin(params) {
            let key = params.adIdx
            delete params.adIdx
            return request.newGet(`super/api/manage-info/admin/${key}`, params).then(({data}) => data);
        },
        getClientDashBoard(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/dashboard/customer/${key}/latest`, params).then(({data}) => data);
        },
        getClientWordCloud(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/wordcloud/customer/${key}`, params).then(({data}) => data);
        },
        getChartDataTotal(params) {
            let key = params.key
            return request.newGet(`normal/api/dashboard/customer/${key}/integrated/news`, params).then(({data}) => data);
        },
        getChartDataSentimentTotal(params) {
            let key = params.key
            return request.newGet(`normal/api/dashboard/customer/${key}/integrated/sentiment/news`, params).then(({data}) => data);
        },
        getChartDataCompetitor(params) {
            let key = params.key
            return request.newGet(`normal/api/dashboard/customer/${key}/competitor/news`, params).then(({data}) => data);
        },
        getChartDataSentimentCompetitor(params) {
            let key = params.key
            return request.newGet(`normal/api/dashboard/customer/${key}/competitor/sentiment/news`, params).then(({data}) => data);
        }
    },
    $crawling: {
        getClientLLMHistory(params) {
            return request.newGet(`normal/api/llm-summary`, params).then(({data}) => data);
        },
        getCrawlingHistory(params) {
            return request.newGet(`normal/api/crawling`, params).then(({data}) => data);
        },
    },

    $board: {
        getNotice(params) {
            return request.newGet("normal/api/announcement", params).then(({data}) => data);
        },
        createNotice(params) {
            return request.newPost("super/api/announcement", params).then(({data}) => data);
        },
        getNoticeDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/announcement/${key}`, params).then(({data}) => data);
        },
        updateNotice(params) {
            let key = params.key
            delete params.key
            return request.newPut(`super/api/announcement/${key}`, params).then(({data}) => data);
        },
        deleteNotice(params) {
            let key = params.key
            delete params.key
            return request.newDelete(`super/api/announcement/${key}`, params).then(({data}) => data);
        },
        getHtmlFail(params) {
            return request.newGet("normal/api/crawling-failed", params).then(({data}) => data);
        },
        getCrawlingFailReasonList(params) {
            return request.newGet("normal/api/crawling-failed/type", params).then(({data}) => data);
        }
    },
    $llm : {
        getLlmHistory(params) {
            return request.newGet("normal/api/llm-summary", params).then(({data}) => data);
        },
        getLlmModels(params) {
            return request.newGet(`open/api/llm-models`, params).then(({data}) => data);
        },
        createLlmModel(params) {
            return request.newPost('super/api/llm-models', params).then(({data}) => data);
        },
        editLlmModel(params) {
            return request.newPut(`super/api/llm-models`, params).then(({data}) => data);
        },
        getCustomerLlmList(params) {
            let key = params.key;
            delete params.key;
            return request.newGet(`super/api/customer/llm-models/${key}`, params).then(({data}) => data);
        },
        deleteLlmModel(params){
            return request.newDelete(`super/api/llm-models`, params).then(({data}) => data);
        },
        stopLlmModel(params) {
            return request.newPut(`super/api/llm-models/disabled`, params).then(({data}) => data);
        }
    },
    $history: {
        getCrawlingHistory(params) {
             return request.newGet(`normal/api/crawling`, params).then(({data}) => data);
        },
        getClientLLMHistory(params) {
            return request.newGet(`normal/api/llm-summary`, params).then(({data}) => data);
        },
        getLlmHistory(params) {
            return request.newGet("normal/api/llm-summary", params).then(({data}) => data);
        },
        getLlmDetailList(params) {
            let key = params.lsIdx;
            delete params.lsIdx;
            return request.newGet(`normal/api/llm-summary/${key}/llm-summary-data`, params).then(({data}) => data);
        },
        getCrawlingDetailList(params) {
            let crIdx = params.crIdx;
            delete params.crIdx;
            return request.newGet(`normal/api/crawling/${crIdx}/data-snapshot`, params).then(({data}) => data);
        },
        getLlmArticleDetail(params) {
            let key = params.key;
            delete params.key;
            return request.newGet( `normal/api/llm-summary-data/${key}`, params).then(({data}) => data);
        },
        getCrawlingDetail(params) {
            let crIdx = params.crIdx;
            delete params.crIdx;
            return request.newGet( `normal/api/crawling/${crIdx}`, params).then(({data}) => data);
        },
        getCrawlingNewsDetail(params) {
            let key = params.key;
            delete params.key;
            return request.newGet( `normal/api/crawling/data-snapshot/${key}`, params).then(({data}) => data);
        },
        getLlmDetail(params) {
            let lsIdx = params.lsIdx;
            return request.newGet( `normal/api/llm-summary/${lsIdx}/statistics`, params).then(({data}) => data);
        }
    },
    $release:{
        getPressReleaseList(params) {
            return request.newGet("normal/api/press-insight", params).then(({data}) => data);
        },
        getPressReleaseDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/press-insight/${key}`, params).then(({data}) => data);
        },
        createPressRelease(params) {
            return request.newPost("normal/api/press-insight", params).then(({data}) => data);
        },
        downloadPressRelease(params) {
            let key = params.key
            let type = params.type
            delete params.key
            delete params.type
            return request.newGet(`normal/api/press-insight/${key}/download/${type}`, params);
        }   
    },
    $open :{
         getLLMModels(params) {
            return request.newGet(`open/api/llm-models`, params).then(({data}) => data);
        },
        getPressThemes(params) {
            return request.newGet(`open/api/press-theme`, params).then(({data}) => data);
        }
    },
    $report : {
        getReportList(params) {
            return request.newGet("normal/api/llm-report", params).then(({data}) => data);
        },
        getReportUserList(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/customer/${key}/llm-summary-data`, params).then(({data}) => data);
        },
        getReportDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/llm-report/${key}`, params).then(({data}) => data);
        },
        updateReport(params) {
            let key = params.key
            delete params.key
            return request.newPut(`normal/api/llm-report/${key}`, params).then(({data}) => data);
        },
        issueSummary(params) {
            return request.newPost('normal/api/llm-report', params).then(({data}) => data);
        }
    },
    $news: {
        getNewsList(params) {
            return request.newGet("normal/api/mail-context", params).then(({data}) => data);
        },
        getNewsDetail(params) {
            let key = params.key
            delete params.key
            return request.newGet(`normal/api/mail-context/${key}`, params).then(({data}) => data);
        },
        sendMail(params) {
            let key = params.key
            delete params.key
            return request.newPost(`normal/api/mail-context/${key}/custom-send`, params).then(({data}) => data);
        },
        updateNews(params) {
            let key = params.key
            delete params.key
            return request.newPut(`normal/api/mail-context/${key}`, params).then(({data}) => data);
        },
        makeMailMerge(params) {
            return request.newPost(`normal/api/mail-context/merge`, params).then(({data}) => data);
        }
    },
    $prompt: {
        getPromptList(params) {
            return request.newGet("normal/api/prompt-catalog", params).then(({data}) => data);
        },
        createPrompt(params){
            return request.newPost("super/api/prompt-catalog", params).then(({data}) => data);
        },
        updatePrompt(params){
            let key = params.key
            delete params.key
            return request.newPut(`super/api/prompt-catalog/${key}`, params).then(({data}) => data);
        },
        deletePrompt(params){
            let key = params.key
            delete params.key
            return request.newDelete(`super/api/prompt-catalog/${key}`, params).then(({data}) => data);
        }
    },
    $define: {
    },
    $handler: {
        authHeader: setAuthInHeader
    },
};

export default $api;
